import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import { CarTitleTemplate } from './CarTitleTemplate';
import { rem } from 'polished';
import { isBrandDS, isBrandOV } from 'src/constants/main';
import { StylesOV } from './Styles.OV';
import { StylesDS } from './Styles.DS';

export const CarTitleStyled = styled(CarTitleTemplate)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${rem(20)} 0;

    .left,
    .right {
        background: ${({ theme }) => theme.colors.primaryBlack};
        width: 35%;
        height: ${rem(1)};
        @media (max-width: ${breakpoints.xs}px) {
            width: 25%;
        }
    }

    .center {
        text-align: center;
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${rem(20)};
        width: 100%;
    }
    ${isBrandOV && StylesOV};
    ${isBrandDS && StylesDS};
`;
